/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.booking', {
            parent: 'board.dinghy',
            url: '/{select}/booking?page&sort&search',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY'],
                pageTitle: 'askApp.dinghyBooking.home.title'
            },
            views: {
                'dinghy@board.dinghy': {
                    templateUrl: 'app/board/dinghy/bookings/dinghy-bookings.html',
                    controller: 'BoardDinghyBookingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'validationDate,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        select: $stateParams.select
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyBooking');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MemberManagementDinghy', function($stateParams, MemberManagementDinghy) {
                    if($stateParams.select) {
                        return MemberManagementDinghy.get({id : $stateParams.select}).$promise;
                    }
                    return null;
                }]
            }
        })
        .state('board.dinghy.booking.edit', {
            parent: 'board.dinghy.booking',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/bookings/dinghy-booking-dialog.html',
                    controller: 'BoardDinghyBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['BoardDinghyBooking', function(BoardDinghyBooking) {
                            return BoardDinghyBooking.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('settings');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.booking', null, { reload: 'board.dinghy.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.booking.delete', {
            parent: 'board.dinghy.booking',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/bookings/dinghy-booking-delete-dialog.html',
                    controller: 'BoardDinghyBookingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BoardDinghyBooking', function(BoardDinghyBooking) {
                            return BoardDinghyBooking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.booking', null, { reload: 'board.dinghy.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.booking.edit-dept', {
            parent: 'board.dinghy.booking',
            url: '/dept/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.booking', null, { reload: 'board.dinghy.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.booking.new-dept', {
            parent: 'board.dinghy.booking',
            url: '/dept/new/{eventId}/{userId}',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id: $stateParams.userId}).$promise;
                        }],
                        entityProject: null,
                        entityDinghyEvent: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id: $stateParams.eventId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.booking', null, { reload: 'board.dinghy.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
